if (!customElements.get('pi-fashion-footer')) {
  customElements.define(
    'pi-fashion-footer',
    class PIFashionFooter extends HTMLElement {
      constructor() {
        super();

        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.handleBreakpoint = this.handleBreakpoint.bind(this);
      }

      connectedCallback() {
        this.details = this.querySelectorAll(
          '.pi-fashion-footer__menu-details'
        );

        if (!this.details.length) return;

        this.updateAccordion();

        this.mediaQuery.addEventListener(
          'change',
          this.handleBreakpoint
        );
      }

      disconnectedCallback() {
        this.mediaQuery.removeEventListener(
          'change',
          this.handleBreakpoint
        );
      }

      handleBreakpoint() {
        this.updateAccordion();
      }

      updateAccordion() {
        const isMobile = this.mediaQuery.matches;

        this.details.forEach((details) => {
          if (isMobile) {
            // Mobile = closed by default
            details.removeAttribute('open');
          } else {
            // Desktop = always open
            details.setAttribute('open', '');
          }
        });
      }
    }
  );
}